package org.matthewo.math

inline fun <reified N : Number> Number.convert(): N = when (N::class) {
    Byte::class -> toByte()
    Short::class -> toShort()
    Int::class -> toInt()
    Long::class -> toLong()
    Float::class -> toFloat()
    Double::class -> toDouble()
    else -> error("cannot convert ${this::class} to ${N::class}")
} as N

@Suppress("UNCHECKED_CAST")
operator fun <T : Number> T.plus(other: T): T = when (this) {
    is Byte -> this + other.toByte()
    is Short -> this + other.toShort()
    is Int -> this + other.toInt()
    is Long -> this + other.toLong()
    is Float -> this + other.toFloat()
    is Double -> this + other.toDouble()
    else -> error("cannot add numbers of type ${this::class} + ${other::class}")
} as T

@Suppress("UNCHECKED_CAST")
operator fun <T : Number> T.minus(other: T): T = when (this) {
    is Byte -> this - other.toByte()
    is Short -> this - other.toShort()
    is Int -> this - other.toInt()
    is Long -> this - other.toLong()
    is Float -> this - other.toFloat()
    is Double -> this - other.toDouble()
    else -> error("cannot subtract numbers of type ${this::class} - ${other::class}")
} as T

@Suppress("UNCHECKED_CAST")
operator fun <T : Number> T.times(other: Number): T = when (this) {
    is Byte -> this * other.toByte()
    is Short -> this * other.toShort()
    is Int -> this * other.toInt()
    is Long -> this * other.toLong()
    is Float -> this * other.toFloat()
    is Double -> this * other.toDouble()
    else -> error("cannot multiply numbers of type ${this::class} * ${other::class}")
} as T

@Suppress("UNCHECKED_CAST")
operator fun <T : Number> T.div(other: Number): T = when (this) {
    is Byte -> this / other.toByte()
    is Short -> this / other.toShort()
    is Int -> this / other.toInt()
    is Long -> this / other.toLong()
    is Float -> this / other.toLong()
    is Double -> this / other.toLong()
    else -> error("cannot divide numbers of type ${this::class} / ${other::class}")
} as T
